import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';

import GeneralPeriodSelector from '../GeneralPeriodSelector/GeneralPeriodSelector';
import PeriodsContext from '../../contexts/PeriodsContext';
import Typography from 'kingpin/atoms/Typography';
import { DateTime } from 'luxon';

const SectionHeader = ({ title }: { title: string }) => (
  <>
    <div
      style={{
        borderBottom: `1px solid var(--color-border-secondary)`,
        marginBottom: '8px',
        marginTop: '8px',
      }}
    />
    <div style={{ marginLeft: '4px', marginBottom: '4px' }}>
      <Typography.Header type="H6" color={'var(--color-grey-5)'}>
        {title}
      </Typography.Header>
    </div>
  </>
);

const CustomerLanePeriodSelector = () => {
  const { periods, selectedPeriod, setSelectedPeriod } =
    useContext(PeriodsContext);
  const [options, setOptions] = useState<DropdownOption[]>([]);

  useEffect(() => {
    const today = DateTime.utc().toISODate();

    const sorted = _.sortBy(periods, 'startDate').reverse();

    const upcomingCount = sorted.filter((p) => p.startDate > today).length;
    const previousCount = sorted.filter((p) => p.endDate < today).length;

    let futureSectionShown = false;
    let currentSectionShown = false;
    let previousSectionShown = false;

    const newOptions: DropdownOption[] = sorted.map((p) => {
      const isCurrent = p.startDate <= today && today <= p.endDate;
      const isFuture = p.startDate > today;

      let renderBefore: (() => JSX.Element) | undefined;

      if (isFuture && !futureSectionShown) {
        futureSectionShown = true;
        const title = upcomingCount === 1 ? 'Upcoming Week' : 'Upcoming Weeks';
        renderBefore = () => <SectionHeader title={title} />;
      } else if (isCurrent && !currentSectionShown) {
        currentSectionShown = true;
        renderBefore = () => <SectionHeader title="Current Week" />;
      } else if (!isFuture && !isCurrent && !previousSectionShown) {
        previousSectionShown = true;
        const title = previousCount === 1 ? 'Previous Week' : 'Previous Weeks';
        renderBefore = () => <SectionHeader title={title} />;
      }

      return {
        key: p.startDate,
        label: p.label,
        renderBefore,
        onSelected: () => setSelectedPeriod(p),
      };
    });

    setOptions(newOptions);
  }, [periods, setSelectedPeriod]);

  return (
    <GeneralPeriodSelector options={options} selectedPeriod={selectedPeriod} />
  );
};

export default CustomerLanePeriodSelector;
